const HeartBeat = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5007 8H10.1007L9.00065 10L7.00065 6L5.90065 8H4.50065M8.00065 3.71462C12.2227 -0.578433 19.4605 7.39439 8.00068 13.8333C-3.45923 7.39442 3.77856 -0.578434 8.00065 3.71462Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default HeartBeat
